<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <app-version-badge></app-version-badge>
</ion-app>
